import {makeStyles} from '@material-ui/core';

export const useInputLabelStyles = makeStyles(() => ({
  label: {
    fontSize: '0.875rem',
    lineHeight: '1.05rem',
    color: '#474747',

    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: '#f44336',
    },
  },
}));

const highlightedInputStyles = {
  '& fieldset': {
    border: '2px solid rgb(0, 117, 209)',
    borderRadius: 0,
  },
  '&:hover fieldset': {
    borderColor: '#0075D1',
  },
  '&.Mui-focused fieldset': {
    boxShadow: 'rgba(0, 117, 209, 0.25) 0 0 0 2px',
    borderColor: 'rgb(0, 117, 209)',
  },

  '& > fieldset': {
    borderRadius: 0,
  },
};

export const useEnabledInputFieldStyles = makeStyles(() => ({
  root: {
    ...highlightedInputStyles,
  },
}));

export const useEnabledSelectStyles = makeStyles(() => ({
  input: {
    ...highlightedInputStyles,
  },
}));
